import styles from "./newCard.module.scss";
import { addPointsInText } from "../../helpers/app";
import { CardProps } from "../../interfaces/components";
import { Link } from 'react-router-dom';
import Favorite from "../../containers/Favorite/FavoriteContainer";
import { Skeleton } from '@mui/material';
import { images } from "../../constants/images";
import Certified from "../Certified/Certified";
import { useState, useEffect } from 'react';

interface NewCardProps extends CardProps {
    showPrimaryDescription?: boolean;
    showSecondaryDescription?: boolean;
    dealerLogo?: string;
    onClickCard?: (event: any) => void;
}

const NewCard = ({
    user,
    item,
    className = '',
    navigation = '',
    pressFavorite,
    loading = false,
    redirect = "",
    onClickCard = () => { },
    showPrimaryDescription = false,
    showSecondaryDescription = false,
    dealerLogo = ""
}: NewCardProps) => {

    const [localLiked, setLocalLiked] = useState(item?.liked);
    const [isUpdating, setIsUpdating] = useState(false);

    const handleChangeFavorite = async (event: any) => {
        event.preventDefault();
        if (user && pressFavorite && !loading && !isUpdating) {
            setIsUpdating(true);
            try {
                await pressFavorite();
                setLocalLiked(!localLiked);
            } finally {
                setIsUpdating(false);
            }
        }
    }

    useEffect(() => {
        setLocalLiked(item?.liked);
    }, [item?.liked]);

    const truncateText = (text: string, maxLength: number) => {
        if (!text) return '';
        return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
    }

    return (
        <Link onClick={onClickCard} to={navigation} className={`${styles.card} ${className}`}>
            <div className={styles.imageContainer}>
                {loading ? (
                    <Skeleton animation="wave" variant="rounded" className={styles.imageCard} />
                ) : (
                    <img
                        loading="lazy"
                        src={item?.pictures[0]?.path ?? images.noImagePublication}
                        className={styles.imageCard}
                        alt={`${item?.title} ${item?.vehicle_data?.version ?? ""} año ${item?.primary_description}`}
                    />
                )}
                {dealerLogo && (
                    <div className={styles.dealerLogo}>
                        <img src={dealerLogo} alt="Dealer logo" />
                    </div>
                )}
                {!loading && item?.status_brief?.code === "sold_out" && (
                    <h3 className={styles.sold}>Vendido</h3>
                )}
                {/* {!loading && item?.certified && (
                    <Certified className={styles.certified} />
                )} */}
                <Favorite
                    onPress={handleChangeFavorite}
                    id={item?._id}
                    liked={localLiked}
                    loading={loading}
                    redirect={redirect}
                    className={styles.favorite}
                />
            </div>
            <div className={styles.content}>
                <div className={styles.infoContainer}>
                    <div className={styles.mainInfo}>
                        <h2 className={styles.title}>{truncateText(item?.title, 18)}</h2>
                        {showPrimaryDescription && item?.vehicle_data?.version && (
                            <h3 className={styles.subtitle}>{truncateText(item?.vehicle_data?.version, 20)}</h3>
                        )}
                    </div>
                    {showSecondaryDescription && (
                        <div className={styles.details}>
                            <span className={styles.year}>{item?.primary_description}</span>
                            <span className={styles.separator}>|</span>
                            <span className={styles.km}>{addPointsInText(item?.secondary_description)}km</span>
                        </div>
                    )}
                </div>
                <div className={styles.priceInfo}>
                    <span className={styles.price}>$ {addPointsInText(item?.price)}</span>
                    {/* <span className={styles.financing}>Desde ${Math.round(Number(item?.price) / 8)}/mes</span> */}
                </div>
            </div>
        </Link>
    );
}

export default NewCard;